import { Box, Typography } from '@mui/material';

const AnnouncementBar = () => {
  const message = null; //"🚧 Scheduled maintenance on Sunday from 2–4 AM CST."; // Replace with Zustand/context logic

  if (!message) return null;

  return (
    <Box
      sx={{
        backgroundColor: '#fffae6',
        borderBottom: '1px solid #ffe58f',
        padding: '0.5rem 1rem',
        textAlign: 'center',
      }}
    >
      <Typography variant='body2' color='text.primary'>
        {message}
      </Typography>
    </Box>
  );
};

export default AnnouncementBar;
